import { injectable } from 'inversify';
import { T360AdapterActionPerformer } from './actionPerformer';
import * as tus from 'tus-js-client';
import { apiFetchPost } from '../../api/fetchUtils';
import { factory } from '../../ConfigLog4j';
import { getAccessToken, handleUploadErrors } from '../utils/utils';
import { T360AdapterAddDocumentActionableEntity } from '../actionableEntity/addDocumentActionableEntity';
import { DCResponse } from '../../types';

const log = factory.getLogger('T360AdapterAddDocumentActionPerformer');

@injectable()
export class T360AdapterAddDocumentActionPerformer extends T360AdapterActionPerformer {
    fetchRequest = apiFetchPost;

    // Create a new tus upload
    performAction(obj: T360AdapterAddDocumentActionableEntity, urlObj: Promise<string>): Promise<DCResponse> {
        const { file, ...obj3 } = Object.assign({}, obj);

        return urlObj.then(async (url) => {
            const accessToken = await getAccessToken();
            log.debug('Performing AddDocument with token');
            return new Promise<DCResponse>((resolve) => {
                const options = {
                    endpoint: url,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    metadata: obj3 as any,
                    headers: {
                        Authorization: 'Bearer ' + accessToken,
                    },
                    onSuccess: () => {
                        const myBlob = new Blob();
                        const init = { status: 200, statusText: 'Pending' };
                        resolve(new DCResponse(myBlob, init));
                    },
                    onError: (err: Error) => {
                        const init = { status: 500, statusText: '' };
                        const myBlob = new Blob();
                        const response2: DCResponse = new Response(myBlob, init) as DCResponse;
                        response2.statusInfo = handleUploadErrors(err.message);
                        resolve(response2);
                    },
                };

                const upload = new tus.Upload(file as Blob | File, options);
                upload.start();
            });
        });
    }
}
